interface RadioOption {
  value: string;
  label: string;
  testId?: string;
  disabled?: boolean;
}

interface RadioGroupProps {
  name: string;
  options: RadioOption[];
  value: string;
  onChange: (name: string, value: string) => void;
  isRow?: boolean;
  label?: string;
}

export function RadioGroup({
  name,
  options,
  value,
  onChange,
  isRow = true,
  label,
}: RadioGroupProps) {
  return (
    <div className="flex items-center gap-3">
      {label && (
        <label className="text-sm font-medium text-neut-700">{label}</label>
      )}
      <div
        className={`flex items-center gap-3 ${isRow ? 'flex-wrap' : 'flex-col items-start'}`}
      >
        {options.map((option) => (
          <label
            key={option.value}
            className={`flex items-center gap-2 ${option.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
          >
            <input
              type="radio"
              name={name}
              data-testid={option.testId}
              className="w-4 h-4 text-prim border-neut-300 focus:ring-prim"
              value={option.value}
              checked={value === option.value}
              disabled={option.disabled}
              onChange={() => onChange(name, option.value)}
            />
            <span
              className={`text-sm ${option.disabled ? 'text-neut-400' : 'text-neut-700'}`}
            >
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
